import { z } from "zod";

/**
 * URL search params for the Admin panel. The whole panel is URL-driven so
 * views are shareable/refresh-safe (mirrors the Search feature).
 */
export const adminSearchSchema = z.object({
  /** Currently-selected FHIR resource type. */
  resourceType: z.string().optional(),
  /** Selected resource id — presence drives the detail + history view. */
  resourceId: z.string().optional(),
  /** Selected patient FHIR id (patient-browse mode). */
  patientId: z.string().optional(),
  // Patient-browse search fields.
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  dob: z.string().optional(),
  mrn: z.string().optional(),
});

export type AdminSearch = z.infer<typeof adminSearchSchema>;
